import React from 'react';
import styled from 'styled-components';
import PageTemplate from '../../components/templates/PageTemplate';
import { MobileHeaderType } from '../../components/layout/ConfigurableMobileHeader';

const PageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 960px;
  padding: 0 24px;
`;

const WalletStatsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  width: 100%;
`;

const WalletStatGroup = styled.div`
  display: flex;
  gap: 24px;
`;

const WalletStat = styled.div`
  background-color: #1E1B2E;
  border-radius: 8px;
  padding: 16px 20px;
`;

const WalletStatLabel = styled.div`
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  margin-bottom: 8px;
`;

const WalletStatValue = styled.div`
  color: #FFFFFF;
  font-size: 24px;
  font-weight: 600;
`;

const WithdrawButton = styled.button`
  background-color: #9333EA;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #A855F7;
  }
`;

const PlusIcon = styled.span`
  margin-right: 8px;
  font-size: 18px;
  font-weight: 300;
`;

const SectionTitle = styled.h2`
  color: #FFFFFF;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 20px;
`;

const PayoutHistoryContainer = styled.div`
  width: 100%;
`;

const PayoutItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const PayoutInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const PayoutDate = styled.div`
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
`;

const PayoutDescription = styled.div`
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
`;

const PayoutAmount = styled.div`
  color: #9333EA;
  font-size: 16px;
  font-weight: 500;
`;

const PayoutStatus = styled.div<{ status: 'pending' | 'dispute' | 'paid' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  
  ${({ status }) => {
    if (status === 'pending') {
      return `
        background-color: rgba(255, 153, 0, 0.1);
        color: #FF9900;
      `;
    } else if (status === 'dispute') {
      return `
        background-color: rgba(255, 59, 48, 0.1);
        color: #FF3B30;
      `;
    } else {
      return `
        background-color: rgba(52, 199, 89, 0.1);
        color: #34C759;
      `;
    }
  }}
`;

const StatusIcon = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
`;

const Payouts: React.FC = () => {
  return (
    <PageTemplate
      mobileHeaderType={MobileHeaderType.SIMPLE}
      mobileHeaderTitle="Payouts"
      showBackButton={true}
      backPath="/wallet"
    >
      <PageContainer>
        <ContentWrapper>
          <WalletStatsContainer>
            <WalletStatGroup>
              <WalletStat>
                <WalletStatLabel>Wallet</WalletStatLabel>
                <WalletStatValue>$26k</WalletStatValue>
              </WalletStat>
              <WalletStat>
                <WalletStatLabel>Lifetime</WalletStatLabel>
                <WalletStatValue>$390k</WalletStatValue>
              </WalletStat>
            </WalletStatGroup>
            <WithdrawButton>
              <PlusIcon>+</PlusIcon>
              Withdraw
            </WithdrawButton>
          </WalletStatsContainer>
          
          <SectionTitle>Payout History</SectionTitle>
          
          <PayoutHistoryContainer>
            <PayoutItem>
              <PayoutInfo>
                <PayoutDate>Jul 1, 2024 5:24 pm</PayoutDate>
                <PayoutDescription>Statement of July Earning</PayoutDescription>
              </PayoutInfo>
              <PayoutAmount>$168</PayoutAmount>
              <PayoutStatus status="pending">
                <StatusIcon style={{ backgroundColor: '#FF9900' }} />
                Pending
              </PayoutStatus>
            </PayoutItem>
            
            <PayoutItem>
              <PayoutInfo>
                <PayoutDate>Jul 1, 2024 5:24 pm</PayoutDate>
                <PayoutDescription>Statement of July Earning</PayoutDescription>
              </PayoutInfo>
              <PayoutAmount>$168</PayoutAmount>
              <PayoutStatus status="dispute">
                <StatusIcon style={{ backgroundColor: '#FF3B30' }} />
                Dispute
              </PayoutStatus>
            </PayoutItem>
            
            <PayoutItem>
              <PayoutInfo>
                <PayoutDate>Jul 1, 2024 5:24 pm</PayoutDate>
                <PayoutDescription>Statement of July Earning</PayoutDescription>
              </PayoutInfo>
              <PayoutAmount>$168</PayoutAmount>
              <PayoutStatus status="paid">
                <StatusIcon style={{ backgroundColor: '#34C759' }} />
                Paid
              </PayoutStatus>
            </PayoutItem>
            
            <PayoutItem>
              <PayoutInfo>
                <PayoutDate>Jul 1, 2024 5:24 pm</PayoutDate>
                <PayoutDescription>Statement of July Earning</PayoutDescription>
              </PayoutInfo>
              <PayoutAmount>$168</PayoutAmount>
              <PayoutStatus status="paid">
                <StatusIcon style={{ backgroundColor: '#34C759' }} />
                Paid
              </PayoutStatus>
            </PayoutItem>
            
            <PayoutItem>
              <PayoutInfo>
                <PayoutDate>Jul 1, 2024 5:24 pm</PayoutDate>
                <PayoutDescription>Statement of July Earning</PayoutDescription>
              </PayoutInfo>
              <PayoutAmount>$168</PayoutAmount>
              <PayoutStatus status="paid">
                <StatusIcon style={{ backgroundColor: '#34C759' }} />
                Paid
              </PayoutStatus>
            </PayoutItem>
            
            <PayoutItem>
              <PayoutInfo>
                <PayoutDate>Jul 1, 2024 5:24 pm</PayoutDate>
                <PayoutDescription>Statement of July Earning</PayoutDescription>
              </PayoutInfo>
              <PayoutAmount>$168</PayoutAmount>
              <PayoutStatus status="paid">
                <StatusIcon style={{ backgroundColor: '#34C759' }} />
                Paid
              </PayoutStatus>
            </PayoutItem>
          </PayoutHistoryContainer>
        </ContentWrapper>
      </PageContainer>
    </PageTemplate>
  );
};

export default Payouts;
